const setStorage = (key: string, value: any) => {
  uni.setStorageSync(key, JSON.stringify(value))
}

const getStorage = (key: string) => {
  return uni.getStorageSync(key) ? JSON.parse(uni.getStorageSync(key) || '') : null
}

const removeStorage = (key: string) => {
  uni.removeStorageSync(key)
}

export { setStorage, getStorage, removeStorage }
